import { render, staticRenderFns } from "./TaskManager.vue?vue&type=template&id=fa44995a&scoped=true"
import script from "./TaskManager.vue?vue&type=script&lang=js"
export * from "./TaskManager.vue?vue&type=script&lang=js"
import style0 from "./TaskManager.vue?vue&type=style&index=0&id=fa44995a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa44995a",
  null
  
)

export default component.exports